import { User, UserRole } from "../types";

export const getUserDisplayName = (user?: User | null, role?: UserRole | null): string => {
  if (!user) return "";
  if (role === "student") return user.Full_Name || "";
  return user.Name || "";
};
